import { z } from 'zod';

import { IdSchema, IsoDateSchema, UnitsSchema, WeekdaySchema } from './common.js';

export const UserSchema = z.object({
  id: IdSchema,
  email: z.string().email(),
  emailVerified: z.boolean(),
  name: z.string().nullable(),
  avatarUrl: z.string().url().nullable(),
  createdAt: IsoDateSchema,
  role: z.enum(['USER', 'ADMIN']),
});
export type User = z.infer<typeof UserSchema>;

export const ProfileSchema = z.object({
  userId: IdSchema,
  bio: z.string().max(500).nullable(),
  units: UnitsSchema,
  weekStartDay: WeekdaySchema,
  defaultRestTimer: z.number().int().min(0).max(3600),
  accentColor: z.enum(['blue', 'green', 'purple', 'orange', 'red']),
  weeklyGoal: z.number().int().min(0).max(14),
  joinDate: IsoDateSchema,
});
export type Profile = z.infer<typeof ProfileSchema>;

export const UpdateProfileSchema = ProfileSchema.omit({
  userId: true,
  joinDate: true,
}).partial();
export type UpdateProfileInput = z.infer<typeof UpdateProfileSchema>;

export const MeResponseSchema = z.object({
  user: UserSchema,
  profile: ProfileSchema,
});
export type MeResponse = z.infer<typeof MeResponseSchema>;
